module.exports = __webpack_public_path__ + "static/media/PictoParcours.ab2c55c5.png";